var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',{attrs:{"label":"Laundry Types","name":"types"}},[_c('laundry-types')],1),_c('el-tab-pane',{attrs:{"label":"Laundry Items","name":"items"}},[_c('laundry-items')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }